var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFloor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 97.481,
    height: 46.593,
    viewBox: "0 0 97.481 46.593",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -9.123)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-8026.38-973.2a8.9,8.9,0,0,1-5.358-1.778h10.718A8.9,8.9,0,0,1-8026.38-973.2Zm-47.053,0a8.9,8.9,0,0,1-5.358-1.778h10.716A8.9,8.9,0,0,1-8073.433-973.2Zm41.175-7.028h-2.891c-.042-.185-.077-.372-.106-.557h-29.3c-.029.186-.065.374-.106.557h-2.89a6.166,6.166,0,0,0,.314-1.873c0-.026,0-.051,0-.077s0-.053,0-.079a6.218,6.218,0,0,0-6.192-6.117,6.2,6.2,0,0,0-6.192,6.2,6.175,6.175,0,0,0,.314,1.95h-2.89a9.014,9.014,0,0,1-.214-1.954,8.993,8.993,0,0,1,8.982-8.984,8.972,8.972,0,0,1,5.865,2.185,8.992,8.992,0,0,1,3.009,5.407h29.3a8.993,8.993,0,0,1,3.008-5.407,8.973,8.973,0,0,1,5.866-2.185,8.994,8.994,0,0,1,8.984,8.984,9.018,9.018,0,0,1-.214,1.954h-2.888a6.169,6.169,0,0,0,.315-1.95,6.2,6.2,0,0,0-6.2-6.2,6.2,6.2,0,0,0-6.193,6.2,6.166,6.166,0,0,0,.315,1.95Z",
    transform: "translate(8101.832 1028.912)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.685,24.9H13.8a1.394,1.394,0,0,1,0-2.789H45.685a1.394,1.394,0,1,1,0,2.789Z",
    transform: "translate(22.191 23.232)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.736,48.13h-6.7a1.394,1.394,0,1,1,0-2.789h6.7A3.462,3.462,0,0,0,93.175,42.4l1.487-9.519a2.467,2.467,0,0,0-2.139-2.828L73.945,27.784a1.405,1.405,0,0,1-.728-.315L56.424,13.354a6.169,6.169,0,0,0-3.966-1.445H26.189A3.769,3.769,0,0,0,23,13.655L15.15,25.941a1.367,1.367,0,0,1-.77.583L4.9,29.382a2.972,2.972,0,0,0-2.069,3.294l1.328,8.5a4.891,4.891,0,0,0,4.856,4.156H20.806a1.394,1.394,0,0,1,0,2.789H9.006a7.661,7.661,0,0,1-7.611-6.515l-1.328-8.5a5.775,5.775,0,0,1,4.019-6.392L13.078,24l7.575-11.853a6.546,6.546,0,0,1,5.536-3.026H52.464a8.959,8.959,0,0,1,5.756,2.1L74.695,25.068l18.167,2.214a5.252,5.252,0,0,1,4.554,6.024L95.93,42.825A6.237,6.237,0,0,1,89.736,48.13Z",
    transform: "translate(0 0)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.927,17.993H12.565c-1.862,0-3.373-.625-3.373-1.394S10.7,15.2,12.565,15.2H89.927c1.862,0,3.373.625,3.373,1.394S91.789,17.993,89.927,17.993Z",
    transform: "translate(-2.59 34.672)",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloor);
export default __webpack_public_path__ + "static/media/floor.1e1d518534587308efd65e3fa5f29bb6.svg";
export { ForwardRef as ReactComponent };